import React, { useState, useEffect } from "react";
import { ListFaceContainer, ButtonImage, Title } from "./FeelingFaces.styled";

import { ReactComponent as Group_1227 } from "../../../themes/Icons/FeelingFaces/Group1227.svg";
import { ReactComponent as Group_1228 } from "../../../themes/Icons/FeelingFaces/Group1228.svg";
import { ReactComponent as Group_1230 } from "../../../themes/Icons/FeelingFaces/Group1230.svg";
import { ReactComponent as Group_1231 } from "../../../themes/Icons/FeelingFaces/Group1231.svg";
import { ReactComponent as Group_1232 } from "../../../themes/Icons/FeelingFaces/Group1232.svg";
import { ReactComponent as Group_1233 } from "../../../themes/Icons/FeelingFaces/Group1233.svg";
import { ReactComponent as Group_1234 } from "../../../themes/Icons/FeelingFaces/Group1234.svg";
import { ReactComponent as Group_1235 } from "../../../themes/Icons/FeelingFaces/Group1235.svg";
import { ReactComponent as Group_1236 } from "../../../themes/Icons/FeelingFaces/Group1236.svg";
import { ReactComponent as Group_1237 } from "../../../themes/Icons/FeelingFaces/Group1237.svg";
import { ReactComponent as Group_1239 } from "../../../themes/Icons/FeelingFaces/Group1239.svg";
import { ReactComponent as Group_1241 } from "../../../themes/Icons/FeelingFaces/Group1241.svg";
import { ReactComponent as Group_1242 } from "../../../themes/Icons/FeelingFaces/Group1242.svg";
import { ReactComponent as Group_1244 } from "../../../themes/Icons/FeelingFaces/Group1244.svg";
import { ReactComponent as Group_1246 } from "../../../themes/Icons/FeelingFaces/Group1246.svg";
import { ReactComponent as Group_1247 } from "../../../themes/Icons/FeelingFaces/Group1247.svg";
import { ReactComponent as Group_1248 } from "../../../themes/Icons/FeelingFaces/Group1248.svg";
import { ReactComponent as Group_1249 } from "../../../themes/Icons/FeelingFaces/Group1249.svg";
import { ReactComponent as Group_1250 } from "../../../themes/Icons/FeelingFaces/Group1250.svg";
import { ReactComponent as Group_1251 } from "../../../themes/Icons/FeelingFaces/Group1251.svg";
import { ReactComponent as Group_1252 } from "../../../themes/Icons/FeelingFaces/Group1252.svg";
import { ReactComponent as Group_1253 } from "../../../themes/Icons/FeelingFaces/Group1253.svg";
import { ReactComponent as Group_1254 } from "../../../themes/Icons/FeelingFaces/Group1254.svg";
import { ReactComponent as Group_1257 } from "../../../themes/Icons/FeelingFaces/Group1257.svg";
import { ReactComponent as Group_1259 } from "../../../themes/Icons/FeelingFaces/Group1259.svg";
import { ReactComponent as Group_1260 } from "../../../themes/Icons/FeelingFaces/Group1260.svg";
import { ReactComponent as Group_1261 } from "../../../themes/Icons/FeelingFaces/Group1261.svg";
import { ReactComponent as Group_1262 } from "../../../themes/Icons/FeelingFaces/Group1262.svg";
import { ReactComponent as Group_1263 } from "../../../themes/Icons/FeelingFaces/Group1263.svg";
import { ReactComponent as Group_1264 } from "../../../themes/Icons/FeelingFaces/Group1264.svg";
import { ReactComponent as Group_1265 } from "../../../themes/Icons/FeelingFaces/Group1265.svg";
import { ReactComponent as Group_1266 } from "../../../themes/Icons/FeelingFaces/Group1266.svg";
import { ReactComponent as Group_1268 } from "../../../themes/Icons/FeelingFaces/Group1268.svg";
import { ReactComponent as Group_1269 } from "../../../themes/Icons/FeelingFaces/Group1269.svg";
import { ReactComponent as Group_1270 } from "../../../themes/Icons/FeelingFaces/Group1270.svg";
import { ReactComponent as Group_1271 } from "../../../themes/Icons/FeelingFaces/Group1271.svg";
import { Tooltip } from "@material-ui/core";
import { CHANGE_STATE_SMILEY } from "../../../GraphQL/Mutations";
import { useMutation } from "@apollo/client";
import { getStateLogin } from "../../../containers/LayoutHome/stateLogin";
import { NotificationManager } from "react-notifications";

const FeelingFaces = ({
  title,
  faces,
  setFaceSelect,
  faceSelect,
  config_smileys,
  smileySelect,
  setSmileySelect,
  runQuerySmileys,
  handler,
  styles = {},
  isMoodMeterSettings,
  type,
}) => {
  const [facesOrder, setFacesOrder] = useState([]);
  const [changeStateSmiley] = useMutation(CHANGE_STATE_SMILEY);

  useEffect(() => {
    setFacesOrder([...faces]);
  }, [config_smileys, faces, setFaceSelect, smileySelect]);

  let getFaceIconComponent = (face) => {
    let faceCurrent = faces.filter((i) => i.smileyIdentifier === face)[0];

    switch (faceCurrent?.smileyIdentifier) {
      case "Group_1227":
        return <Group_1227 />;
      case "Group_1228":
        return <Group_1228 />;
      case "Group_1230":
        return <Group_1230 />;
      case "Group_1231":
        return <Group_1231 />;
      case "Group_1232":
        return <Group_1232 />;
      case "Group_1233":
        return <Group_1233 />;
      case "Group_1234":
        return <Group_1234 />;
      case "Group_1235":
        return <Group_1235 />;
      case "Group_1236":
        return <Group_1236 />;
      case "Group_1237":
        return <Group_1237 />;
      case "Group_1239":
        return <Group_1239 />;
      case "Group_1241":
        return <Group_1241 />;
      case "Group_1242":
        return <Group_1242 />;
      case "Group_1244":
        return <Group_1244 />;
      case "Group_1246":
        return <Group_1246 />;
      case "Group_1247":
        return <Group_1247 />;
      case "Group_1248":
        return <Group_1248 />;
      case "Group_1249":
        return <Group_1249 />;
      case "Group_1250":
        return <Group_1250 />;
      case "Group_1251":
        return <Group_1251 />;
      case "Group_1252":
        return <Group_1252 />;
      case "Group_1253":
        return <Group_1253 />;
      case "Group_1254":
        return <Group_1254 />;
      case "Group_1257":
        return <Group_1257 />;
      case "Group_1259":
        return <Group_1259 />;
      case "Group_1260":
        return <Group_1260 />;
      case "Group_1261":
        return <Group_1261 />;
      case "Group_1262":
        return <Group_1262 />;
      case "Group_1263":
        return <Group_1263 />;
      case "Group_1264":
        return <Group_1264 />;
      case "Group_1265":
        return <Group_1265 />;
      case "Group_1266":
        return <Group_1266 />;
      case "Group_1268":
        return <Group_1268 />;
      case "Group_1269":
        return <Group_1269 />;
      case "Group_1270":
        return <Group_1270 />;
      case "Group_1271":
        return <Group_1271 />;
    }
  };

  const setFace = (faceObject) => {
    if (config_smileys) {
      setSmileySelect(
        faceObject.recordState !== ""
          ? faces.filter(
            (i) => i.smileyIdentifier === faceObject.smileyIdentifier
          )[0]
          : 0
      );
    } else {
      faceObject.icon = getFaceIconComponent(faceObject?.smileyIdentifier);
      setFaceSelect(
        faceObject.recordState !== ""
          ? faces.filter(
            (i) => i.smileyIdentifier === faceObject.smileyIdentifier
          )[0]
          : 0
      );
      handler();
    }
  };

  useEffect(() => {
    if (smileySelect) {
      let newState =
        smileySelect.recordState === "Active" ? `${"INACTIVE"}` : `${"ACTIVE"}`;
      changeStateSmiley({
        variables: {
          idSmiley: smileySelect.idSmiley,
          newState: newState,
          userChange: getStateLogin(),
        },
      })
        .then((response) => {
          let err = response.withError;
          if (!err) {
            /* NotificationManager.success(
              'The smiley of mood meter config has been updated',
              '',
              5000,
            ) */
            runQuerySmileys();
          }
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    }
  }, [smileySelect]);

  return (
    <>
      {title && <Title>{title}</Title>}
      <ListFaceContainer
        config={config_smileys}
        len={facesOrder?.length}
        isSmiley
        {...(!isMoodMeterSettings && { style: { paddingTop: "15px" } })}
      >
        <div style={{ ...styles }} className="smiley-faces-container">
          {facesOrder.map((element, index) => {
            return (
              <Tooltip key={index + type} arrow title={element?.smileyFeel}>
                <ButtonImage
                  isMoodMeterSettings={isMoodMeterSettings}
                  len={facesOrder?.length}
                  config={config_smileys}
                  hidden={() => {
                    if (faceSelect?.idSmiley) {
                      if (faceSelect?.idSmiley !== element?.idSmiley)
                        return true;
                    }
                    return false;
                  }}
                  onClick={() => setFace(element)}
                  select={element?.recordState === "Active" ? true : false}
                  config_smileys={config_smileys}
                >
                  {getFaceIconComponent(element?.smileyIdentifier)}
                  <br />
                  {
                    !config_smileys && <label>{element?.smileyFeel}</label>
                    /*|| 
                  (config_smileys && element?.recordState == 'Active' && <label>{element?.smileyFeel}</label>)*/
                  }
                </ButtonImage>
              </Tooltip>
            );
          })}
        </div>
      </ListFaceContainer>
    </>
  );
};

export default FeelingFaces;
